
export {
	CLIP_BACKSTEP,
	CLIP_FORESTEP,
	VID_ATTACH_URL,
	VID_DETACH_URL,
	VID_PLAYLIST_URL,
	EDIT_STAT_URL,
	EDIT_MATCH_URL,
	EDIT_EVENT_URL,
	UNDO_EDITS_URL,
	EDIT_TOUCH_STAT_URL,
	UNDO_TOUCH_EDITS_URL,
	Actions,
	NumericColors,
	ReportFillColors,
	Tabs,
	TeamLevels,
	get_action_label
};

// ---------------------------
// CONFIGURATION
// ---------------------------

var CLIP_BACKSTEP  = 5;
var CLIP_FORESTEP  = 5;

var VID_ATTACH_URL       = "/vidix/attach";
var VID_DETACH_URL       = "/vidix/detach";
var VID_PLAYLIST_URL     = "/vidix/playlist";
var EDIT_STAT_URL        = "/api/editstat";
var EDIT_MATCH_URL       = "/api/editmatch";
var EDIT_EVENT_URL       = "/api/editevent";
var UNDO_EDITS_URL       = "/api/undoedits";
var EDIT_TOUCH_STAT_URL  = "/api/edittouchstat";
var UNDO_TOUCH_EDITS_URL = "/api/undotouchedits";


// TODO: can this be deleted?
var Tabs = [
	["SETUP",          "setup_page"],
	["CAPTURE",        "capture_page"],
	//["ROTATION STATS", "rotation_page"],
	//["PLAYER STATS",   "player_page"],
	["POINT LOG",      "log_page"]
];

// TODO: can this be deleted?
var TeamLevels = [
	["uv",     "University (varsity)"],
	["ujv",    "University (junior varsity)"],
	["ud1",    "University D1"],
	["ud2",    "University D2"],
	["ud3",    "University D3"],
	["udn",    "University NAIA"],
	["uo",     "University Other"],
	["jc",     "Junior College"],
	["hsv",    "High School (varsity)"],
	["hssjv",  "High School (junior varsity)"],
	["ms",     "Middle School"],
	["club18", "Club 17/18's"],
	["club16", "Club 15/16's"],
	["club14", "Club 13/14's"],
	["club12", "Club 11/12's"]
];

var Actions = {};
Actions.touch = [
	["touch",  "Touch"],
	["settch", "Set Touch"],
	["srvtch", "Serve Touch"],
	["digtch", "Dig Touch"],
	["blktch", "Block Touch"],
	["atktch", "Attack Touch"],
	["srtch",  "Serve Receive Touch"],
	["fbptch", "Free Ball Pass Touch"]
];

Actions.attack = [
	["spike", "Spike"],
	["htatt", "Hit Still in Play"],
	["spk",   "Spike Error"],
	["tip",   "Tip"],
	["tipe",  "Tip Error"],
	["dump",  "Dump"],
	["dumpe", "Dump Error"],
	["dbh",   "Down Ball Hit"],
	["dbhe",  "Down Ball Hit Error"]
];

Actions.receive = [
	["rcv",    "Receive Error"],
	["1pass",  "1-Receive"],
	["2pass",  "2-Receive"],
	["3pass",  "3-Receive"],
	["0pass",  "Over Pass in Play"],
	["xpass",  "Receive (Unrated)"],
	["fbp",    "Free Ball Pass Error"],
	["0fbp",   "FB Over Pass In Play"],
	["1fbp",   "1-Free Ball Pass"],
	["2fbp",   "2-Free Ball Pass"],
	["3fbp",   "3-Free Ball Pass"],
	["xfbp",   "Free Ball Pass (Unrated)"],
	["fbrip",  "FB Return In Play"],
	["2br",    "2nd Ball Return Error"],
	["3br",    "3rd Ball Return Error"],
	["whb",    "Whose Ball? Error"]
];

Actions.defend = [
	["srv",    "Serve Error"],
	["1srv",   "1-Serve"],
	["2srv",   "2-Serve"],
	["3srv",   "3-Serve"],
	["xsrv",   "Serve (Unrated)"],
	["ace",    "Ace"],
	["dgatt",  "Dig"],
	["dig",    "Dig Error"],
	["blck",   "Block"],
	["blksip", "Block Still In Play"],
	["blcke",  "Block Error"]
];

Actions.set = [
	["setin",   "Set Error (In-System)"],
	["1setin",  "1-Set (In-System)"],
	["2setin",  "2-Set (In-System)"],
	["3setin",  "3-Set (In-System)"],
	["setout",  "Set Error (Out-of-System)"],
	["1setout", "1-Set (Out-of-System)"],
	["2setout", "2-Set (Out-of-System)"],
	["3setout", "3-Set (Out-of-System)"]
];

Actions.earned = [
	["ace",   "Ace"],
	["spike", "Spike"],
	["tip",   "Tip"],
	["dump",  "Dump"],
	["dbh",   "Down Ball Hit"],
	["blck",  "Block"],
	["asst",  "Assist"]
];

Actions.errors = [
	["srv",   "Serve"],
	["rcv",   "Receive"],
	["spk",   "Spike"],
	["dig",   "Dig"],
	["tip",   "Tip"],
	["set",   "Set"],
	["dump",  "Dump"],
	["fbp",   "Free Ball Receive"],
	["dbh",   "Down Ball Hit"],
	["2br",   "2nd Ball Return"],
	["blck",  "Block"],
	["3br",   "3rd Ball Return"],
	["whb",   "Whose Ball?"]
];

Actions.faults = [
	["fault", "Fault (Unspecified)"],
	["net",   "Net"],
	["bhndl", "Ball Handling"],
	["undr",  "Under"],
	["otn",   "Over the Net"],
	["foot",  "Foot Fault"],
	["oor",   "Out of Rotation"],
	["bra",   "Back Row Attack"]
];

Actions.in_rally = [
	["dgatt",  "Dig"],
	["htatt",  "Hit Still In Play"],
	["blksip", "Block Still In Play"],
	["0pass",  "Over Pass In Play"],
	["1pass",  "1-Receive"],
	["2pass",  "2-Receive"],
	["3pass",  "3-Receive"],
	["xpass",  "Receive (Unrated)"],
	["0fbp",   "FB Over Pass In Play"],
	["1fbp",   "1-Free Ball Pass"],
	["2fbp",   "2-Free Ball Pass"],
	["3fbp",   "3-Free Ball Pass"],
	["xfbp",   "Free Ball Pass (Unrated)"],
	["1srv",   "1-Serve"],
	["2srv",   "2-Serve"],
	["3srv",   "3-Serve"],
	["xsrv",   "Serve (Unrated)"],
	["fbrip",  "FB Return In Play"]
];

Actions.meta = [
	["startvideo", "-Start Video-"],
];


// TODO: can this be deleted?
var ReportFillColors = {
	'overall': '#6666ff;',
	'earned' : '#009900;',
	'errors' : '#ff9900;',
	'faults' : '#ff3300;'
};

// TODO: can this be deleted?
var NumericColors = {
	'positive': '#000000;',
	'zero':     '#999999;',
	'negative': '#ff0000;'
};

var Reports = {};
Reports.player = {
	"overall": "byplayer_us_overall",
	"earned":  "byplayer_us_earned",
	"errors":  "byplayer_us_errors",
	"faults":  "byplayer_us_faults",
	"serving": "byplayer_us_serving"
};

Reports.rotation = {
	"overall": "byrotation_us_overall",
	"earned":  "byrotation_us_earned",
	"errors":  "byrotation_us_errors",
	"faults":  "byrotation_us_faults"
};

function get_action_label(cat, code) {
	cat = cat.replace('-', '_');
	for (var i = 0; i < Actions[cat].length; i++) {
		if (Actions[cat][i][0] == code) {
			return Actions[cat][i][1];
		}
	}

	return "?";
}
